import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=7239a5bd"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7239a5bd')) {
      api.createRecord('7239a5bd', component.options)
    } else {
      api.reload('7239a5bd', component.options)
    }
    module.hot.accept("./Kpi.vue?vue&type=template&id=7239a5bd", function () {
      api.rerender('7239a5bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Kpis/Kpi.vue"
export default component.exports